import axios from 'axios'

const axiosClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_API
})

axiosClient.defaults.headers.common['Authorization'] = 'Token '+ process.env.VUE_APP_API_TOKEN

export default axiosClient
